// Libraries
import { useMutation } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";

// Hooks
import { useAxios } from "hooks/useAxios";

// Store
import { setCoverage } from "store/reducers/features";
import { AppState } from "store/reducers/Reducer";

// Utils
import { handleAxiosRequest, handleToast, ServerError } from "utils";
import { toastMsg, USER_API } from "config";

// Types
import { CoverageState } from "store/types/features.types";
import { status } from "store/types/enum";

export const useFeatures = () => {
  const axios = useAxios();
  const dispatch = useDispatch();

  const { coverage } = useSelector((state: AppState) => state.features);
  const project = useSelector((state: AppState) => state.project);
  const projectId = project.project_id?.toString();
  const documentId = (
    project?.active_document_id ||
    project?.selected_document_id ||
    project?.documents?.[0]?.document_id
  )?.toString();

  const saveCoverage = (data: CoverageState) => {
    dispatch(setCoverage(data));
  };
  const getCoverage = useMutation(
    () => {
      // Validate that we have both projectId and documentId before making the API call
      if (!projectId || !documentId) {
        throw new Error("Project ID or Document ID is missing");
      }

      return handleAxiosRequest(
        axios.get<CoverageState>(USER_API.getOrPatchCoverage(projectId, documentId))
      );
    },
    {
      onSuccess: (data) => {
        saveCoverage(data);
      },
      onError: (error) => {
        if (!(error instanceof ServerError)) {
          handleToast(toastMsg.genericServerErr, status.ERROR);
          return;
        }
        throw error;
      },
    }
  );

  return { coverage, getCoverage };
};
